// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Daily Reward Modal Overlay */
.daily-reward-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Modal Container */
.daily-reward-modal {
    position: relative;
    width: 85%;
    max-width: 350px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    animation: scaleIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    border: none;
    outline: none;
    background: transparent;
    box-shadow: none;
}

@keyframes scaleIn {
    from {
        opacity: 0;
        transform: scale(0.8);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

/* Stars Decoration */
.stars-decoration {
    position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow: visible;
}

.star {
    position: absolute;
    color: #D5BE9B;
    font-size: 1rem;
    animation: twinkle 2s ease-in-out infinite;
}

.star-1 {
    top: 10%;
    left: 10%;
    opacity: 0.5;
    font-size: 0.8rem;
    animation-delay: 0s;
}

.star-2 {
    top: 15%;
    left: 25%;
    opacity: 0.7;
    font-size: 1.2rem;
    animation-delay: 0.3s;
}

.star-3 {
    top: 12%;
    left: 40%;
    opacity: 0.4;
    font-size: 0.6rem;
    animation-delay: 0.6s;
}

.star-4 {
    top: 18%;
    left: 55%;
    opacity: 0.6;
    font-size: 0.9rem;
    animation-delay: 0.9s;
}

.star-5 {
    top: 20%;
    left: 70%;
    opacity: 0.8;
    font-size: 1rem;
    animation-delay: 1.2s;
}

.star-6 {
    top: 14%;
    left: 85%;
    opacity: 0.5;
    font-size: 0.7rem;
    animation-delay: 1.5s;
}

@keyframes twinkle {

    0%,
    100% {
        opacity: 0.3;
        transform: scale(1);
    }

    50% {
        opacity: 1;
        transform: scale(1.2);
    }
}

/* Title */
.daily-reward-title {
    font-family: 'CormorantSC-Medium', 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 28px;
    font-weight: 500;
    color: #D5BE9B;
    margin: 0 0 8px 0;
    letter-spacing: 0.02em;
    text-align: center;
}

/* Subtitle */
.daily-reward-subtitle {
    font-family: 'Urbanist-Regular', 'Inter', sans-serif;
    font-size: 14px;
    color: rgba(213, 190, 155, 0.6);
    margin: 0 0 30px 0;
    text-align: center;
}

/* Coin Container */
.coin-container {
    position: relative;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.coin-icon {
    width: 180px;
    height: 180px;
    object-fit: contain;
    filter: drop-shadow(0 0 30px rgba(226, 191, 74, 0.8));
    animation: float 3s ease-in-out infinite;
    transition: all 0.3s ease;
}

.coin-icon.claimed {
    animation: coinBounce 0.5s ease forwards;
}

@keyframes float {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-10px);
    }
}

@keyframes coinBounce {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.2);
    }

    100% {
        transform: scale(1);
    }
}

/* Claim Button */
.claim-button {
    background-color: #D5BE9B;
    padding: 16px 50px;
    border: none;
    border-radius: 30px;
    font-family: 'CormorantSC-Medium', 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 18px;
    font-weight: 600;
    color: #000;
    cursor: pointer;
    transition: all 0.3s ease;
    max-width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 180px;
    min-height: 52px;
}

.claim-button:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(213, 190, 155, 0.4);
}

.claim-button:active:not(:disabled) {
    transform: translateY(0);
}

.claim-button.claiming {
    cursor: wait;
    opacity: 0.7;
}

.claim-button.claimed {
    background-color: #edfb7f;
    cursor: default;
}

.claim-button:disabled {
    cursor: not-allowed;
}

/* Loading Spinner */
.loading-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid rgba(0, 0, 0, 0.2);
    border-top-color: #000;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Responsive */
@media (max-width: 480px) {
    .daily-reward-modal {
        padding: 24px 20px;
    }

    .daily-reward-title {
        font-size: 24px;
    }

    .daily-reward-subtitle {
        font-size: 12px;
    }

    .coin-icon {
        width: 140px;
        height: 140px;
    }

    .claim-button {
        font-size: 16px;
        padding: 14px 40px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/DailyRewardModal.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,yDAAyD;IACzD,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;IAEI;;QAEI,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,qBAAqB;IACzB;AACJ;;AAEA,UAAU;AACV;IACI,kFAAkF;IAClF,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,aAAa;AACb;IACI,oDAAoD;IACpD,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,qDAAqD;IACrD,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;;IAEI;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,kFAAkF;IAClF,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,sBAAsB;IACtB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,eAAe;AACf;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ","sourcesContent":["/* Daily Reward Modal Overlay */\r\n.daily-reward-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.8);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 9999;\r\n    animation: fadeIn 0.3s ease;\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n/* Modal Container */\r\n.daily-reward-modal {\r\n    position: relative;\r\n    width: 85%;\r\n    max-width: 350px;\r\n    padding: 30px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n    animation: scaleIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\r\n    border: none;\r\n    outline: none;\r\n    background: transparent;\r\n    box-shadow: none;\r\n}\r\n\r\n@keyframes scaleIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: scale(0.8);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n/* Stars Decoration */\r\n.stars-decoration {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    pointer-events: none;\r\n    overflow: visible;\r\n}\r\n\r\n.star {\r\n    position: absolute;\r\n    color: #D5BE9B;\r\n    font-size: 1rem;\r\n    animation: twinkle 2s ease-in-out infinite;\r\n}\r\n\r\n.star-1 {\r\n    top: 10%;\r\n    left: 10%;\r\n    opacity: 0.5;\r\n    font-size: 0.8rem;\r\n    animation-delay: 0s;\r\n}\r\n\r\n.star-2 {\r\n    top: 15%;\r\n    left: 25%;\r\n    opacity: 0.7;\r\n    font-size: 1.2rem;\r\n    animation-delay: 0.3s;\r\n}\r\n\r\n.star-3 {\r\n    top: 12%;\r\n    left: 40%;\r\n    opacity: 0.4;\r\n    font-size: 0.6rem;\r\n    animation-delay: 0.6s;\r\n}\r\n\r\n.star-4 {\r\n    top: 18%;\r\n    left: 55%;\r\n    opacity: 0.6;\r\n    font-size: 0.9rem;\r\n    animation-delay: 0.9s;\r\n}\r\n\r\n.star-5 {\r\n    top: 20%;\r\n    left: 70%;\r\n    opacity: 0.8;\r\n    font-size: 1rem;\r\n    animation-delay: 1.2s;\r\n}\r\n\r\n.star-6 {\r\n    top: 14%;\r\n    left: 85%;\r\n    opacity: 0.5;\r\n    font-size: 0.7rem;\r\n    animation-delay: 1.5s;\r\n}\r\n\r\n@keyframes twinkle {\r\n\r\n    0%,\r\n    100% {\r\n        opacity: 0.3;\r\n        transform: scale(1);\r\n    }\r\n\r\n    50% {\r\n        opacity: 1;\r\n        transform: scale(1.2);\r\n    }\r\n}\r\n\r\n/* Title */\r\n.daily-reward-title {\r\n    font-family: 'CormorantSC-Medium', 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 28px;\r\n    font-weight: 500;\r\n    color: #D5BE9B;\r\n    margin: 0 0 8px 0;\r\n    letter-spacing: 0.02em;\r\n    text-align: center;\r\n}\r\n\r\n/* Subtitle */\r\n.daily-reward-subtitle {\r\n    font-family: 'Urbanist-Regular', 'Inter', sans-serif;\r\n    font-size: 14px;\r\n    color: rgba(213, 190, 155, 0.6);\r\n    margin: 0 0 30px 0;\r\n    text-align: center;\r\n}\r\n\r\n/* Coin Container */\r\n.coin-container {\r\n    position: relative;\r\n    margin-bottom: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.coin-icon {\r\n    width: 180px;\r\n    height: 180px;\r\n    object-fit: contain;\r\n    filter: drop-shadow(0 0 30px rgba(226, 191, 74, 0.8));\r\n    animation: float 3s ease-in-out infinite;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.coin-icon.claimed {\r\n    animation: coinBounce 0.5s ease forwards;\r\n}\r\n\r\n@keyframes float {\r\n\r\n    0%,\r\n    100% {\r\n        transform: translateY(0);\r\n    }\r\n\r\n    50% {\r\n        transform: translateY(-10px);\r\n    }\r\n}\r\n\r\n@keyframes coinBounce {\r\n    0% {\r\n        transform: scale(1);\r\n    }\r\n\r\n    50% {\r\n        transform: scale(1.2);\r\n    }\r\n\r\n    100% {\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n/* Claim Button */\r\n.claim-button {\r\n    background-color: #D5BE9B;\r\n    padding: 16px 50px;\r\n    border: none;\r\n    border-radius: 30px;\r\n    font-family: 'CormorantSC-Medium', 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    color: #000;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    max-width: 80%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-width: 180px;\r\n    min-height: 52px;\r\n}\r\n\r\n.claim-button:hover:not(:disabled) {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 6px 20px rgba(213, 190, 155, 0.4);\r\n}\r\n\r\n.claim-button:active:not(:disabled) {\r\n    transform: translateY(0);\r\n}\r\n\r\n.claim-button.claiming {\r\n    cursor: wait;\r\n    opacity: 0.7;\r\n}\r\n\r\n.claim-button.claimed {\r\n    background-color: #edfb7f;\r\n    cursor: default;\r\n}\r\n\r\n.claim-button:disabled {\r\n    cursor: not-allowed;\r\n}\r\n\r\n/* Loading Spinner */\r\n.loading-spinner {\r\n    width: 20px;\r\n    height: 20px;\r\n    border: 2px solid rgba(0, 0, 0, 0.2);\r\n    border-top-color: #000;\r\n    border-radius: 50%;\r\n    animation: spin 0.8s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 480px) {\r\n    .daily-reward-modal {\r\n        padding: 24px 20px;\r\n    }\r\n\r\n    .daily-reward-title {\r\n        font-size: 24px;\r\n    }\r\n\r\n    .daily-reward-subtitle {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .coin-icon {\r\n        width: 140px;\r\n        height: 140px;\r\n    }\r\n\r\n    .claim-button {\r\n        font-size: 16px;\r\n        padding: 14px 40px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
